const {
  isString
} = require('lodash');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
 * Used to turn the first name / last name of the employee
 * selected under Weld Passes
 * into the abbreviated "stencil" value.
 *
 * @function evalute - evaluate employeeInitialsBehavior
 */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const value = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);
  if (value === undefined) {
    return undefined;
  }
  const {
    title
  } = value;
  if (title === undefined) {
    return undefined;
  }
  const initials = [];
  if (isString(title)) {
    const names = title.split(' ');
    names.forEach(name => {
      if (name.length > 0) {
        initials.push(name[0]);
      }
    });
  }
  return initials.join('');
};
module.exports = {
  evaluate
};